import styled from 'styled-components';

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: linear-gradient(#E68AB4, #A84FB2);
  margin-right: 8px;
`;

export default Dot;